import { render, staticRenderFns } from "./AdminFilterEditTable.vue?vue&type=template&id=5374584c&scoped=true"
import script from "./AdminFilterEditTable.vue?vue&type=script&lang=js"
export * from "./AdminFilterEditTable.vue?vue&type=script&lang=js"
import style0 from "./AdminFilterEditTable.vue?vue&type=style&index=0&id=5374584c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374584c",
  null
  
)

export default component.exports